<script>
import Integrations from '../../mixins/integrations';

export default {
  mixins: [Integrations],

  data: () => ({
    config: {
      client_key: '',
      client_path: '',
      client_secret: '',
      client_account: '',
    },
    integration: {
      name: 'vtex',
    },
  }),
};
</script>

<template>
  <div class="vtex-integration">
    <i
      class="fa fa-spin fa-circle-o-notch"
      v-if="loading"
    />
    <div
      class="form-group"
      v-else
    >
      <p class="form-text">
        {{ __('Configure seu acesso ao Vtex informando o nome da conta, a rota da conta, o AppToken e o AppKey para continuar.') }}
      </p>
      <form @submit.prevent="save()">
        <div class="row">
          <div class="col-6">
            <label class="lg">{{ __('Nome da conta') }}</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.client_account"
                required="required"
              >
            </p>
          </div>
          <div class="col-6">
            <label class="lg">{{ __('Rota da conta') }}</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.client_path"
                required="required"
              >
            </p>
          </div>
          <div class="col-6">
            <label class="lg">AppToken</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.client_secret"
                required="required"
              >
            </p>
          </div>
          <div class="col-6">
            <label class="lg">AppKey</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.client_key"
                required="required"
              >
            </p>
          </div>
        </div>
        <div class="text-right">
          <p>
            <button
              class="btn btn-sm btn-box"
              type="submit"
            >
              {{ __('Salvar') }}
            </button>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>
